/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react';
import { AvatarSmallInterface } from './avatarTypes';
import './avatar.scss';
import '../../constants/_global.scss';
import { ReactComponent as Camera } from '../../assets/camera.svg';

const AvatarSmall: React.FC<AvatarSmallInterface> = ({
  onExit,
  avatar,
  profileName,
  isMobile,
  onAvatarClick,
}) => {
  const [imgUrl, setImgUrl] = useState<string | null>(null);
  const exit = 'Выйти';

  useEffect(() => {
    if (avatar) {
      setImgUrl(avatar);
    }
  }, [avatar]);

  const nameSlice = (name: string) => `${name.slice(0, 9)}.`;

  return (
    <div className="flexRow">
      <button className="circleSmall" onClick={onAvatarClick}>
        {imgUrl ? (
          <img src={imgUrl} alt="аватар" className="avatarSmall" />
        ) : (
          <Camera className="svgSmall" />
        )}
      </button>
      <div className="columnSmall">
        {isMobile ?? (
          <h3 className="profileText name">{nameSlice(profileName)}</h3>
        )}
        <button className="spanGlobal btnSmall" onClick={onExit} type="button">
          {exit}
        </button>
      </div>
    </div>
  );
};

export default AvatarSmall;
